import React, { Component } from 'react';

// External components
import { Map, InfoWindow, Marker } from 'google-maps-react';
import GoogleApiWrapper from './GoogleApiWrapper.jsx';
// Internal components
import Tile from '../../common/Tile/Tile.jsx';

class MapContainer extends Component {
    state = {
        activeMarker: {},
        selectedPlace: {},
        showingInfoWindow: false,
        currentLocation: {},
    };

    onMarkerClick = (props, marker) =>
        this.setState({
            activeMarker: marker,
            selectedPlace: props,
            showingInfoWindow: true
        });

    onInfoWindowClose = () =>
        this.setState({
            activeMarker: null,
            showingInfoWindow: false
        });

    onMapClicked = () => {
        if (this.state.showingInfoWindow)
            this.setState({
                activeMarker: null,
                showingInfoWindow: false
            });
    };

    componentDidMount() {
        this.updateBounds();
    }

    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            this.updateBounds();
        }

        if (this.props.currentLocation !== prevProps.currentLocation) {
            var bounds = this.map.map.getBounds();
            bounds.extend(this.props.currentLocation);
            this.map.map.fitBounds(bounds);
        }
    }

    render() {
        const selected = this.state.selectedPlace;
        const { digitalProducts, digitalText } = this.props;
        const availableOnline = !isNaN(selected.productTypeId) ? digitalProducts.includes(parseInt(selected.productTypeId)) : false;
        return (
            <Map
                ref={(ref) => { this.map = ref; }}
                google={this.props.google}
                onClick={this.onMapClicked}
                style={{ height: '600px', position: 'relative', width: '100%' }}>

                {this.props.data.map(place => 
                    <Marker
                        key={place.productId}
                        url={place.productUrl}
                        name={place.pDisplayName}
                        venue={place.city}
                        celeb={place.celebUrlName}
                        productTypeId={place.productTypeId}
                        productThumbImgSrc={place.productThumbImgSrc}
                        onClick={this.onMarkerClick}
                        position={{ 
                            lat: place.latitude && !isNaN(place.latitude) ? parseFloat(place.latitude) : null,
                            lng: place.longitude && !isNaN(place.longitude) ? parseFloat(place.longitude) : null
                        }}
                    />
                )}

                {this.props.currentLocation &&
                    <Marker
                        position={this.props.currentLocation}
                        icon={{
                            url: "/location_dot.png",
                            scaledSize: new google.maps.Size(25, 25)
                        }}
                    />
                }

                <InfoWindow
                    maxWidth={240}
                    marker={this.state.activeMarker}
                    onClose={this.onInfoWindowClose}
                    visible={this.state.showingInfoWindow}>
                    <Tile
                        classOverride="io-gm-tile"
                        key={selected.key}
                        src={selected.productThumbImgSrc}
                        eyebrow={selected.celeb}
                        title={selected.name}
                        actionUrl={selected.url}
                        location={availableOnline ? digitalText : selected.venue}
                        bkgColor="white"
                    >
                    </Tile>
                </InfoWindow>
            </Map>
        );
    }

    updateBounds() {
        this.map.map.fitBounds(this.calculateBounds(this.props.data));

        // Special case: zoom out a bit
        if (this.props.data.length == 1) {
            this.map.map.setZoom(13);
        }
    }

    calculateBounds(places) {
        const bounds = new window.google.maps.LatLngBounds();

        if (places.length == 0) {
            bounds.extend(new google.maps.LatLng(85, -180));
            bounds.extend(new google.maps.LatLng(-85, 180));
            return bounds;
        }

        places.map(place => {
            const lat = place.latitude && !isNaN(place.latitude) ? parseFloat(place.latitude) : null;
            const lng = place.longitude && !isNaN(place.longitude) ? parseFloat(place.longitude) : null;
            const latLng = new window.google.maps.LatLng(lat, lng);
            bounds.extend(latLng);
            return latLng;
        });

        return bounds;
    }

}

export default GoogleApiWrapper({
    apiKey: g_google_api_key
})(MapContainer);
 